export default __webpack_public_path__ + "static/media/E06.83291cb4.mp3";